import React, { useEffect, useState, useRef } from 'react';
import styles from './styles';
import stylesOp from './optionsStyles';
import { Tooltip, IconButton } from '@material-ui/core';
import {
  getMatchInventory,
  getUnMatchInventory,
  SaveApiResMessage,
} from '@/actions';
import { Icons } from '@/assets';
import { ReactSVG } from 'react-svg';
import LoadingV2 from '@/components/Loading';
import Options from '@/components/Global/Options';

export default ({
  DATA = [],
  EmptiesTableTheadTitle,
  ExportsTableTheadTitle,
  Del,
  Edit,
  getInventoryMatchList,
  currentPage,
  smartMatchStatus,
  loadingSmartMatch,
}) => {
  const cls = styles();
  const clsOp = stylesOp();
  const [NEWDATA, setNEWDATA] = useState([]);
  const [loadingMatch, setLoadingMatch] = useState(false);
  const [hover, setHover] = useState(false);
  const [selectedContainer, setSelectedContainer] = useState([]);
  const [savings, setSavings] = useState([]);
  const [newDataList, setNewDataList] = React.useState({
    matches: {},
    newData: {},
  });
  const [optionsEm, setOptionsEm] = React.useState({
    open: false,
    DATA: [],
  });
  const [optionsEx, setOptionsEx] = React.useState({
    open: false,
    DATA: [],
  });

  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  const mainScroll = document.getElementsByTagName('main')[0];
  useEffect(() => {
    setNEWDATA(DATA);
  }, [DATA]);
  useEffect(() => {
    setLoadingMatch(loadingSmartMatch);
  }, [loadingSmartMatch]);

  React.useEffect(() => {
    // Portal dropdowns don't need jQuery slideDown/slideUp anymore
  }, [optionsEm.open]);
  React.useEffect(() => {
    // Portal dropdowns don't need jQuery slideDown/slideUp anymore
  }, [optionsEx.open]);

  const formatPrice = (price) => {
    if (price) {
      // If price is a string, remove commas and convert to a number
      const numericPrice =
        typeof price === 'string' ? parseFloat(price.replace(/,/g, '')) : price;

      // Ensure the value is a valid number
      if (isNaN(numericPrice)) {
        return '$0'; // Handle invalid input gracefully
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(numericPrice);
    } else {
      return '$0';
    }
  };

  const formatDateTimeToUTC = (dateString) => {
    const date = new Date(dateString);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const formattedDate =
      `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
      `${String(date.getUTCDate()).padStart(2, '0')}-` +
      `${String(date.getUTCFullYear()).slice(-2)}`; // Slice the last two digits for the year

    if (!dateString) {
      return '-';
    }
    // Check if both hours and minutes are 00
    else if (hours === 0 && minutes === 0) {
      return formattedDate; // Return only the date
    } else {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0'
      )} ${formattedDate}`; // Return time and date
    }
  };

  const getActivContainers = (inventory, target) => {
    if (inventory) {
      let activeContainers = [];
      let deactiveContainers = [];
      inventory.containers.forEach((container) => {
        if (container.status === 1) {
          activeContainers.push(container);
        } else if (container.status === 0) {
          deactiveContainers.push(container);
        }
      });

      if (deactiveContainers.length === 0) {
        return (
          <input
            type="checkbox"
            className={`all ${cls.containerChecBox}`}
            checked={true}
          />
        );
      } else if (activeContainers.length === 0) {
        return (
          <input
            type="checkbox"
            className={`any ${cls.containerChecBox}`}
            checked={false}
          />
        );
      } else {
        return (
          <input
            type="checkbox"
            checked={true}
            className={`some ${cls.containerChecBox}`}
          />
        );
      }
    }
  };

  const handlematch = (id, type, item, inventoryId, exportId) => {
    if (id === selectedContainer?.selected?.id) {
      return setSelectedContainer([]);
    }
    if (id === selectedContainer?.selectedMatch?.id) {
      return setSelectedContainer((prevState) => ({
        ...prevState,
        selectedMatch: null,
      }));
    }

    if (selectedContainer?.selected?.type === 'em') {
      if (selectedContainer?.exports?.includes(id)) {
        // notify('Empty Matched');
        SaveApiResMessage({
          title: null,
          message: 'Empty Matched',
          mode: 'success',
        });
        setSelectedContainer((prevState) => ({
          ...prevState,
          empties: null,
          exports: null,
          exportId: { type: 'exportId', id: exportId ?? exportId },
          selectedMatch: { type: type, id: id },
        }));
        return true;
      }
    }
    if (selectedContainer?.selected?.type === 'ex') {
      if (selectedContainer?.empties?.includes(id)) {
        // notify('Export Matched');
        SaveApiResMessage({
          title: null,
          message: 'Export Matched',
          mode: 'success',
        });
        setSelectedContainer((prevState) => ({
          ...prevState,
          empties: null,
          exports: null,
          inventoryId: { type: 'inventoryId', id: inventoryId ?? inventoryId },
          selectedMatch: { type: type, id: id },
        }));
      }
      return true;
    }

    if (id === selectedContainer?.selected) {
      setSelectedContainer(null);
    } else {
      const emptiesIds = Object.values(item?.empties).flatMap((em) =>
        Object.values(em?.containers).map((cn) => cn.id)
      );

      const exportsIds = Object.values(item?.exports).flatMap((ex) =>
        Object.values(ex?.bookings).map((bk) => bk.id)
      );

      setSelectedContainer({
        empties: emptiesIds,
        exports: exportsIds,
        selected: { type: type, id: id },
        inventoryId: { type: 'inventoryId', id: inventoryId },
        exportId: { type: 'exportId', id: exportId },
      });
      // notify(
      //   `Now Select from ${
      //     selectedContainer?.selected?.type === 'em'
      //       ? 'Empties'
      //       : selectedContainer?.selected?.type === 'ex'
      //       ? 'Exports'
      //       : ''
      //   } List. OR for Cancel, reselect selected item`
      // );
      SaveApiResMessage({
        title: 'Info',
        message: `Now Select from ${
          selectedContainer?.selected?.type === 'em'
            ? 'Empties'
            : selectedContainer?.selected?.type === 'ex'
            ? 'Exports'
            : ''
        } List. OR for Cancel, reselect selected item`,
        mode: 'info',
      });
    }
  };

  useEffect(() => {
    // setLoadingMatch(false);
    handleMatchApi();
  }, [
    selectedContainer?.selected?.id !== undefined &&
      selectedContainer?.selectedMatch?.id !== undefined,
  ]);
  const handleMatchApi = (i) => {
    // setShareLink({ loading: i.id });
    setLoadingMatch(true);
    if (
      selectedContainer?.selected?.id !== undefined &&
      selectedContainer?.selectedMatch?.id !== undefined
    ) {
      getMatchInventory(selectedContainer)
        .then((res) => {
          getInventoryMatchList();
          setSelectedContainer([]);
          // setLoadingMatch(false);
        })
        .catch((err) => {
          // notify(err, 'warning');
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
        });
    }
  };

  const handleUnMatchApi = (cnid, bkid, inventoryId, exportId) => {
    let req = {
      export_id: exportId,
      empty_id: inventoryId,
      booking_id: bkid,
      container_id: cnid,
    };
    setLoadingMatch(true);

    getUnMatchInventory(req)
      .then((res) => {
        getInventoryMatchList();
        setSelectedContainer([]);
        // setLoadingMatch(false);
        // notify('Unmatched');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Unmatched',
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };
  const extractMatches = (response) => {
    const matches = {};
    const newData = { list: {} };

    Object.keys(response).forEach((key, index) => {
      const { company_name, size_type, empties, exports, cabin } =
        response[key];

      const matchedManualBookingIDs = new Set();
      const matchedSmartBookingIDs = new Set();
      const matchedBookingsManual = new Set();
      const matchedBookingsSmart = new Set();
      const matchedManualContainerIDs = new Set();
      const matchedSmartContainerIDs = new Set();
      const matchedContainersManual = new Set();
      const matchedContainersSmart = new Set();

      const containers = empties.flatMap((empty) =>
        empty.containers.map((container) => ({
          ...container,
          address: empty.address,
          saving: container.savings || {}, // Initialize saving if undefined
        }))
      );

      // Update bookings in exports with saving

      const updatedExports = exports.map((exp) => ({
        ...exp,
        bookings: exp.bookings.map((booking) => {
          const containerWithSaving = containers.find((container) => container);
          const bookingID = booking.id;
          return {
            ...booking,
            address: exp.address,
            saving: containerWithSaving?.savings
              ? { [bookingID]: containerWithSaving.savings[booking.id] }
              : null,
          };
        }),
      }));

      const matchManualArray = containers
        .map((container) => {
          const bookingIndex = updatedExports
            .flatMap((exp) => exp.bookings)
            .findIndex((booking) => booking.id === container.booking_id);

          if (bookingIndex !== -1) {
            const booking = updatedExports.flatMap((exp) => exp.bookings)[
              bookingIndex
            ];

            matchedManualBookingIDs.add(booking.id);

            matchedBookingsManual.add({
              ...booking,
              saving: container?.savings ? container.savings[booking.id] : null,
            });

            matchedManualContainerIDs.add(container.id);
            matchedContainersManual.add(container);
            return {
              booking,
              container,
            };
          }
          return null;
        })
        .filter(Boolean);

      const matchSmartArray = containers
        .map((container) => {
          const bookingIndex = updatedExports
            .flatMap((exp) => exp.bookings)
            .findIndex(
              (booking) => booking.id === container.suggested_booking_id
            );

          if (bookingIndex !== -1) {
            const booking = updatedExports.flatMap((exp) => exp.bookings)[
              bookingIndex
            ];

            matchedSmartBookingIDs.add(booking.id);

            matchedBookingsSmart.add({
              ...booking,
              saving: container?.savings ? container.savings[booking.id] : null,
            });

            matchedSmartContainerIDs.add(container.id);
            matchedContainersSmart.add(container);
            return {
              booking,
              container,
            };
          }
          return null;
        })
        .filter(Boolean);

      if (matchManualArray.length > 0) {
        matches[index] = matchManualArray;
      }

      newData.list[index] = {
        company_name,
        size_type,
        cabin,
        empties,
        exports: updatedExports, // Use updated exports with saving
        // matched: matchManualArray,
        matchedManualBookingIDs: Array.from(matchedManualBookingIDs),
        matchedSmartBookingIDs: Array.from(matchedSmartBookingIDs),
        matchedBookingsManual: Array.from(matchedBookingsManual), // Convert set to array
        matchedBookingsSmart: Array.from(matchedBookingsSmart), // Convert set to array
        matchedManualContainerIDs: Array.from(matchedManualContainerIDs),
        matchedSmartContainerIDs: Array.from(matchedSmartContainerIDs),
        matchedContainersManual: Array.from(matchedContainersManual),
        matchedContainersSmart: Array.from(matchedContainersSmart),
      };
    });
    setNewDataList({ matches, newData });
    setNEWDATA(DATA);

    return {
      matches,
      newData,
    };
  };

  useEffect(() => {
    const result = extractMatches(DATA, setNewDataList);
    setNewDataList(result.newData.list);
    setLoadingMatch(false);
  }, [DATA]);

  useEffect(() => {
    let someCompletedCheckboxs = document.getElementsByClassName('some');
    let allCompletedCheckboxs = document.getElementsByClassName('all');
    let notCompletedCheckboxs = document.getElementsByClassName('any');
    for (let i = 0; i < someCompletedCheckboxs.length; i++) {
      someCompletedCheckboxs[i].indeterminate = true;
    }
    for (let i = 0; i < allCompletedCheckboxs.length; i++) {
      allCompletedCheckboxs[i].indeterminate = false;
    }
    for (let i = 0; i < notCompletedCheckboxs.length; i++) {
      notCompletedCheckboxs[i].indeterminate = false;
      notCompletedCheckboxs[i].checked = false;
    }
  }, [getActivContainers, getInventoryMatchList]);

  const loadingRef = useRef(null);
  const tableRef = useRef(null);
  const tableHeaderInnerRef = useRef(null);
  const tableHeaderRef = useRef(null);

  const [tableWidth, setTableWidth] = useState(0);
  const [spanWidth, setSpanWidth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (loadingRef.current && tableHeaderInnerRef.current) {
        const loadingElementTop =
          loadingRef.current.getBoundingClientRect().top;

        if (loadingElementTop <= 69) {
          tableHeaderRef.current.classList.add(cls.fix);
          tableRef.current.classList.add(cls.tableTopMargin);
          setIsHeaderFixed(true);
          // Sync header widths when fix class is added
        } else {
          tableHeaderRef.current.classList.remove(cls.fix);
          tableRef.current.classList.remove(cls.tableTopMargin);
          setIsHeaderFixed(false);
          // Reset first header width when fix class is removed
          if (tableHeaderInnerRef.current) {
            tableHeaderInnerRef.current.style.width = '';
          }
        }
      }
      syncScroll('loadingId');
      setOptionsEx({ open: false });
      setOptionsEm({ open: false });
    };
    const updateWidth = () => {
      if (tableRef.current && tableHeaderInnerRef.current) {
        const tableCurrentWidth =
          tableRef.current.getBoundingClientRect().width;
        setTableWidth(tableCurrentWidth);
      }
    };

    const updateHeadWidth = () => {
      if (loadingRef.current && tableHeaderRef.current) {
        const tableeCurrentWidth =
          loadingRef.current.getBoundingClientRect().width;
        setSpanWidth(tableeCurrentWidth);
      }
    };

    const syncScroll = (source) => {
      if (loadingRef.current && tableHeaderRef.current) {
        if (source === 'loadingId') {
          // Sync horizontal scroll from listContainer to header
          tableHeaderRef.current.scrollLeft = loadingRef.current.scrollLeft;
        } else if (source === 'tableHeaderInnerId') {
          // Sync horizontal scroll from header to listContainer
          loadingRef.current.scrollLeft = tableHeaderRef.current.scrollLeft;
        }
      }
    };

    updateWidth();
    updateHeadWidth();

    window.updateWidth = updateWidth;
    window.updateHeadWidth = updateHeadWidth;
    window.syncScroll = syncScroll;

    const handleScroll1 = () => syncScroll('loadingId');
    const handleScroll2 = () => syncScroll('tableHeaderInnerId');

    // Store current ref values for cleanup
    const loadingElement = loadingRef.current;
    const tableHeaderElement = tableHeaderRef.current;

    if (loadingElement) {
      loadingElement.addEventListener('scroll', handleScroll1);
    }

    if (tableHeaderElement) {
      tableHeaderElement.addEventListener('scroll', handleScroll2);
    }

    mainScroll.addEventListener('scroll', handleScroll);
    mainScroll.addEventListener('resize', updateWidth);
    mainScroll.addEventListener('resize', updateHeadWidth);
    mainScroll.addEventListener('scroll', updateWidth);
    mainScroll.addEventListener('scroll', updateHeadWidth);

    // Cleanup on component unmount
    return () => {
      mainScroll.removeEventListener('scroll', handleScroll);
      mainScroll.removeEventListener('resize', updateWidth);
      mainScroll.removeEventListener('resize', updateHeadWidth);
      mainScroll.removeEventListener('scroll', updateWidth);
      mainScroll.removeEventListener('scroll', updateHeadWidth);

      if (loadingElement) {
        loadingElement.removeEventListener('scroll', handleScroll1);
      }

      if (tableHeaderElement) {
        tableHeaderElement.removeEventListener('scroll', handleScroll2);
      }
    };
  }, [DATA, cls.fix, cls.tableTopMargin]);

  useEffect(() => {
    if (tableHeaderRef.current) {
      tableHeaderRef.current.style.width = `${spanWidth - 23}px`;
    }
  }, [spanWidth]);

  useEffect(() => {
    if (tableHeaderInnerRef.current) {
      tableHeaderInnerRef.current.style.width = `${tableWidth - 23}px`;
    }
  }, [tableWidth]);

  const optionsEmRef = useRef(null);
  const optionsExRef = useRef(null);
  const [items, setItems] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [emptiesTitle, setEmptiesTitle] = useState([]);
  const [exportsTitle, setExportsTitle] = useState([]);
  const [changedList, setChangedList] = useState([...items]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [tableType, setTtableType] = useState(null);

  const toggleItems = (type) => {
    setTtableType(type);

    // Calculate position for dropdown
    const calculateDropdownPosition = (refElement) => {
      if (refElement?.current) {
        const rect = refElement.current.getBoundingClientRect();

        if (isHeaderFixed) {
          // When fixed, position relative to viewport but ensure it's visible
          return {
            top: rect.bottom + 5, // Add small offset from button
            left: Math.max(10, rect.right - 280), // Ensure it doesn't go off-screen left, 280px is dropdown width
          };
        } else {
          // When not fixed, position relative to document
          return {
            top: rect.bottom + window.scrollY + 5,
            left: Math.max(10, rect.right + window.scrollX - 280),
          };
        }
      }
      return { top: 0, left: 0 };
    };

    if (type === 'streetTurnEmptiesTable') {
      setOptionsEm((prev) => ({ ...prev, open: !prev.open }));
    } else if (type === 'streetTurnExportsTable') {
      setOptionsEx((prev) => ({ ...prev, open: !prev.open }));
    }

    const itemsToSet =
      type === 'streetTurnEmptiesTable'
        ? EmptiesTableTheadTitle
        : type === 'streetTurnExportsTable'
        ? ExportsTableTheadTitle
        : '';

    setItems(itemsToSet);
  };

  useEffect(() => {
    const mergedItems = [
      ...emptiesTitle.map((item) => ({
        ...item,
        table: 'streetTurnEmptiesTable',
      })),
      ...exportsTitle.map((item) => ({
        ...item,
        table: 'streetTurnExportsTable',
      })),
    ];
    setAllItems(mergedItems);
  }, [emptiesTitle, exportsTitle]);

  useEffect(() => {
    setEmptiesTitle(EmptiesTableTheadTitle);
    setExportsTitle(ExportsTableTheadTitle);
  }, [EmptiesTableTheadTitle, ExportsTableTheadTitle]);

  const handleDragStart = (index) => setDraggedItem(index);

  const handleDragOverEmpties = (e, index) => {
    e.preventDefault(); // Allow drop
    if (draggedItem === null || draggedItem === index) return;

    const updatedItems = [...emptiesTitle];
    const dragged = updatedItems[draggedItem];
    updatedItems.splice(draggedItem, 1);
    updatedItems.splice(index, 0, dragged);

    setDraggedItem(index);
    setEmptiesTitle(updatedItems);
    setChangedList(updatedItems);
  };

  const handleDragOverExports = (e, index) => {
    e.preventDefault(); // Allow drop
    if (draggedItem === null || draggedItem === index) return;

    const updatedItems = [...exportsTitle];
    const dragged = updatedItems[draggedItem];
    updatedItems.splice(draggedItem, 1);
    updatedItems.splice(index, 0, dragged);

    setDraggedItem(index);
    setExportsTitle(updatedItems);
    setChangedList(updatedItems);
  };

  const handleDragEnd = () => setDraggedItem(null);

  const toggleVisibility = (index) => {
    const totalVisibleCount = allItems.filter((item) => item.show).length;
    const updatedItem = emptiesTitle.find((item, i) => i === index);
    if (updatedItem?.show && totalVisibleCount < 15) {
      // notify('You must keep at least 15 columns active.');
      SaveApiResMessage({
        title: 'Warning',
        message: 'You must keep at least 15 columns active.',
        mode: 'warning',
      });
      return;
    }
    if (!updatedItem?.show && totalVisibleCount > 16) {
      // notify('You cannot activate more than 17 columns.');
      SaveApiResMessage({
        title: 'Warning',
        message: 'You cannot activate more than 17 columns.',
        mode: 'warning',
      });
      return;
    }
    const updatedItems = emptiesTitle.map((item, i) =>
      i === index ? { ...item, show: !item.show } : item
    );
    console.log(updatedItems);
    setEmptiesTitle(updatedItems);
    setItems(updatedItems);
    setChangedList(updatedItems);
  };
  const toggleVisibilityy = (index) => {
    const totalVisibleCount = allItems.filter((item) => item.show).length;
    const updatedItem = exportsTitle.find((item, i) => i === index);
    if (updatedItem?.show && totalVisibleCount < 15) {
      // notify('You must keep at least 15 columns active.');
      SaveApiResMessage({
        title: 'Warning',
        message: 'You must keep at least 15 columns active.',
        mode: 'warning',
      });
      return;
    }
    if (!updatedItem?.show && totalVisibleCount > 16) {
      // notify('You cannot activate more than 17 columns.');
      SaveApiResMessage({
        title: 'Warning',
        message: 'You cannot activate more than 17 columns.',
        mode: 'warning',
      });
      return;
    }
    const updatedItems = exportsTitle.map((item, i) =>
      i === index ? { ...item, show: !item.show } : item
    );
    setExportsTitle(updatedItems);
    setItems(updatedItems);
    setChangedList(updatedItems);
  };

  const [gradientPosition, setGradientPosition] = useState(0);
  useEffect(() => {
    // Reset gradient position on status change
    setGradientPosition(0);

    let animationFrame;
    const updateGradient = () => {
      setGradientPosition((prev) => {
        if (prev >= 100) {
          cancelAnimationFrame(animationFrame); // Stop animation when complete
          return prev;
        }
        return prev + 5; // Progress the gradient smoothly
      });
      animationFrame = requestAnimationFrame(updateGradient); // Request the next frame
    };

    updateGradient(); // Start the animation
    return () => cancelAnimationFrame(animationFrame); // Cleanup on unmount
  }, [smartMatchStatus]); // Restart animation when `smartMatchStatus` changes

  const gradientStyle = {
    background: `linear-gradient(to right, #FFEFCC ${gradientPosition}%, #f6f6f6 ${gradientPosition}%)`,
    transition: 'background 2s linear', // Smooth transition for each update
  };
  const gradientManualStyle = {
    background: `linear-gradient(to right, #E0FAEC ${gradientPosition}%, #f6f6f6 ${gradientPosition}%)`,
    transition: 'background 2s linear', // Smooth transition for each update
  };

  return (
    <>
      {newDataList.empties ?? (
        <div ref={loadingRef} id="loadingId" className={cls.listContainer}>
          {loadingMatch === true ? <LoadingV2 isFullscreen /> : ''}
          <div className={cls.tableCentertDiv}>
            <table ref={tableRef} id="table" className={cls.listTableCenter}>
              <thead ref={tableHeaderRef}>
                <span ref={tableHeaderInnerRef} id="tableHeaderInnerId">
                  <span className={cls.thead}>
                    <th
                      className={cls.tableThTop}
                      style={{ flex: 0.1765 }}></th>
                    <th className={cls.tableThTop} style={{ flex: 1.008 }}>
                      <span className={cls.tableThTopTiltlesSpan}>
                        <ReactSVG src={Icons.importIcon} className={cls.icon} />
                        Your Empties
                      </span>
                      <div className={clsOp.filterContainer} ref={optionsEmRef}>
                        <div className={clsOp.headerBar}>
                          <span className={clsOp.title}></span>
                          <div className={clsOp.rocw3}>
                            <div
                              className={clsOp.filterRow}
                              onClick={() =>
                                toggleItems('streetTurnEmptiesTable')
                              }>
                              <ReactSVG
                                src={Icons.options}
                                className={clsOp.filter}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className={cls.tableThTop} style={{ flex: 0.6 }}>
                      <span className={cls.tableThTopTiltlesSpan}>
                        <ReactSVG src={Icons.importIcon} className={cls.icon} />
                        Your Exports
                      </span>
                      <div className={clsOp.filterContainer} ref={optionsExRef}>
                        <div className={clsOp.headerBar}>
                          <span className={clsOp.title}></span>
                          <div className={clsOp.rocw3}>
                            {/* {children} */}
                            <div
                              className={clsOp.filterRow}
                              onClick={() =>
                                toggleItems('streetTurnExportsTable')
                              }>
                              <ReactSVG
                                src={Icons.options}
                                className={clsOp.filter}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </th>
                  </span>
                  <span className={cls.thead}>
                    <td className={cls.tableTD} style={{ flex: 0.19 }}>
                      <tr className={cls.tableRowHeader}>
                        {/* <th className={cls.tableTh} style={{ flex: 0.25 }}>
                      #
                    </th> */}
                        <th className={cls.tableTh} style={{ flex: 0.7 }}>
                          Size
                        </th>
                        <th className={cls.tableTh} style={{ flex: 1 }}>
                          SSL
                        </th>
                      </tr>
                    </td>
                    <td className={cls.tableTD} style={{ flex: 1 }}>
                      <tr className={cls.tableRowHeader} style={{ flex: 1 }}>
                        {EmptiesTableTheadTitle.map((header, index) =>
                          header?.show === false ? (
                            ''
                          ) : (
                            <th
                              className={cls.tableTh}
                              key={index}
                              style={{ flex: header.flex }}>
                              {header.label}
                            </th>
                          )
                        )}
                      </tr>
                    </td>
                    <td className={cls.tableTD} style={{ flex: 0.6 }}>
                      <tr className={cls.tableRowHeader} style={{ flex: 1 }}>
                        {ExportsTableTheadTitle.map((header, index) =>
                          header?.show === false ? (
                            ''
                          ) : (
                            <th
                              className={cls.tableTh}
                              key={index}
                              style={{ flex: header.flex }}>
                              {header.label}
                            </th>
                          )
                        )}
                        <th className={cls.tableTh} style={{ flex: 1.1 }}>
                          Saving
                        </th>
                      </tr>
                    </td>
                  </span>
                </span>
              </thead>
              <tbody className={cls.tbody}>
                {
                  // newDataList.empties ??
                  Object.values(NEWDATA).map((i, idx) =>
                    i?.empties?.every(
                      (empty) => empty.containers?.length === 0
                    ) ? (
                      ''
                    ) : (
                      <tr className={cls.tableRowMain} key={idx}>
                        <td
                          style={{
                            height:
                              Object.values(i?.exports || {}).reduce(
                                (sum, ex) => sum + (ex.bookings_count || 0),
                                0
                              ) <=
                              Object.values(i?.empties || {}).reduce(
                                (sum, em) => sum + (em.containers_count || 0),
                                0
                              )
                                ? `${
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : Object.values(i?.exports || {}).reduce(
                                    (sum, ex) => sum + (ex.bookings_count || 0),
                                    0
                                  ) >
                                  Object.values(i?.empties || {}).reduce(
                                    (sum, em) =>
                                      sum + (em.containers_count || 0),
                                    0
                                  )
                                ? `${
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : '49px',
                            flex: 0.181,
                          }}
                          className={cls.tableTD}>
                          <tr
                            style={{ flex: 0.25 }}
                            className={cls.tableRowLeft}>
                            {/* <td className={cls.tableTDMain} style={{ flex: 1 }}>
                          {idx + 1 + (currentPage - 1) * 10}
                        </td> */}
                            <td
                              className={cls.tableTDMain}
                              style={{ flex: 0.7 }}>
                              {i.size_type}
                            </td>
                            <td className={cls.tableTDMain} style={{ flex: 1 }}>
                              {i.company_name}
                            </td>
                          </tr>
                        </td>
                        <td
                          style={{
                            height:
                              Object.values(i?.exports || {}).reduce(
                                (sum, ex) => sum + (ex.bookings_count || 0),
                                0
                              ) <=
                              Object.values(i?.empties || {}).reduce(
                                (sum, em) => sum + (em.containers_count || 0),
                                0
                              )
                                ? `${
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : Object.values(i?.exports || {}).reduce(
                                    (sum, ex) => sum + (ex.bookings_count || 0),
                                    0
                                  ) >
                                  Object.values(i?.empties || {}).reduce(
                                    (sum, em) =>
                                      sum + (em.containers_count || 0),
                                    0
                                  )
                                ? `${
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : '49px',
                            flex: 1,
                          }}
                          className={cls.tableTD}>
                          {newDataList[idx]?.matchedContainersManual.map(
                            (container, mchca) => (
                              <>
                                <tr
                                  className={cls.tableRowMatchedImport}
                                  style={{ ...gradientManualStyle, flex: 1 }}>
                                  {EmptiesTableTheadTitle.map(
                                    (header, index) => {
                                      const objectKey = header.object;

                                      return header?.show === false ? (
                                        ''
                                      ) : (
                                        <td
                                          key={`${index}new`}
                                          className={cls.tableTDMain}
                                          style={{ flex: header.flex }}>
                                          {objectKey === 'name'
                                            ? container.name
                                            : ''}
                                          {objectKey === 'chases'
                                            ? container.chases
                                            : ''}
                                          {objectKey === 'gated_out'
                                            ? formatDateTimeToUTC(
                                                container.gated_out
                                              )
                                            : ''}
                                          {objectKey === 'gated_in'
                                            ? formatDateTimeToUTC(
                                                container.gated_in
                                              )
                                            : ''}
                                          {objectKey === 'loc'
                                            ? container?.address?.city
                                            : ''}
                                          {objectKey === 'return_appointment'
                                            ? 'No Apt. Available'
                                            : ''}
                                          {objectKey === 'return_terminals'
                                            ? container.return_terminals
                                            : ''}
                                          {objectKey === 'est_per_diem'
                                            ? formatPrice(
                                                container.est_per_diem
                                              )
                                            : ''}
                                          {objectKey === 'lfd'
                                            ? formatDateTimeToUTC(
                                                container.last_free_day
                                              )
                                            : ''}
                                          {objectKey === 'dual'
                                            ? container.return_dual_terminals
                                            : ''}
                                        </td>
                                      );
                                    }
                                  )}
                                </tr>
                              </>
                            )
                          )}
                          {smartMatchStatus
                            ? newDataList[idx]?.matchedContainersSmart.map(
                                (container, mch6ca) => (
                                  <>
                                    <tr
                                      className={cls.tableRowMatchedSmartImport}
                                      style={{ ...gradientStyle, flex: 1 }}>
                                      {EmptiesTableTheadTitle.map(
                                        (header, index) => {
                                          const objectKey = header.object;

                                          return header?.show === false ? (
                                            ''
                                          ) : (
                                            <td
                                              key={`${index}new`}
                                              className={cls.tableTDMain}
                                              style={{ flex: header.flex }}>
                                              {objectKey === 'name'
                                                ? container.name
                                                : ''}
                                              {objectKey === 'chases'
                                                ? container.chases
                                                : ''}
                                              {objectKey === 'gated_out'
                                                ? formatDateTimeToUTC(
                                                    container.gated_out
                                                  )
                                                : ''}
                                              {objectKey === 'gated_in'
                                                ? formatDateTimeToUTC(
                                                    container.gated_in
                                                  )
                                                : ''}
                                              {objectKey === 'loc'
                                                ? container?.address?.city
                                                : ''}
                                              {objectKey ===
                                              'return_appointment'
                                                ? 'No Apt. Available'
                                                : ''}
                                              {objectKey === 'return_terminals'
                                                ? container.return_terminals
                                                : ''}
                                              {objectKey === 'est_per_diem'
                                                ? formatPrice(
                                                    container.est_per_diem
                                                  )
                                                : ''}
                                              {objectKey === 'lfd'
                                                ? formatDateTimeToUTC(
                                                    container.last_free_day
                                                  )
                                                : ''}
                                              {objectKey === 'dual'
                                                ? container.return_dual_terminals
                                                : ''}
                                            </td>
                                          );
                                        }
                                      )}
                                    </tr>
                                  </>
                                )
                              )
                            : ''}
                          {newDataList[idx]?.empties.map((em, idxx) =>
                            Object.values(em?.containers).map(
                              (container, idxxx) => (
                                <>
                                  {newDataList[
                                    idx
                                  ]?.matchedManualContainerIDs.includes(
                                    container.id
                                  ) ? (
                                    ''
                                  ) : newDataList[
                                      idx
                                    ]?.matchedSmartContainerIDs.includes(
                                      container.id
                                    ) && smartMatchStatus ? (
                                    ''
                                  ) : selectedContainer?.empties?.includes(
                                      container.id
                                    ) &&
                                    selectedContainer?.selected.type ===
                                      'ex' ? (
                                    <tr
                                      onMouseEnter={() => {
                                        setHover(true);
                                        setSavings(container.savings);
                                      }}
                                      onMouseLeave={() => {
                                        setHover(false);
                                      }}
                                      onClick={() =>
                                        handlematch(
                                          container.id,
                                          'em',
                                          i,
                                          container.inventory_id
                                        )
                                      }
                                      className={
                                        selectedContainer?.selectedMatch?.id ===
                                        container.id
                                          ? cls.tableRowSelected
                                          : selectedContainer?.empties?.includes(
                                              container.id
                                            ) &&
                                            selectedContainer?.selected.type ===
                                              'ex'
                                          ? cls.selectableItem
                                          : selectedContainer?.selected?.id ===
                                            container.id
                                          ? cls.tableRowSelected
                                          : cls.tableRow
                                      }
                                      style={{ flex: 1, minHeight: 40 }}>
                                      {EmptiesTableTheadTitle.map(
                                        (header, index) => {
                                          const objectKey = header.object;

                                          return header?.show === false ? (
                                            ''
                                          ) : (
                                            <td
                                              key={`${index}new`}
                                              className={cls.tableTDMain}
                                              style={{
                                                flex: header.flex,
                                              }}>
                                              {objectKey === 'name'
                                                ? container.name
                                                : ''}
                                              {objectKey === 'chases'
                                                ? container.chases
                                                : ''}
                                              {objectKey === 'gated_out'
                                                ? formatDateTimeToUTC(
                                                    container.gated_out
                                                  )
                                                : ''}
                                              {objectKey === 'gated_in'
                                                ? formatDateTimeToUTC(
                                                    container.gated_in
                                                  )
                                                : ''}
                                              {objectKey === 'loc'
                                                ? em?.address?.city
                                                : ''}
                                              {objectKey ===
                                              'return_appointment'
                                                ? 'No Apt. Available'
                                                : ''}
                                              {objectKey === 'return_terminals'
                                                ? container.return_terminals
                                                : ''}
                                              {objectKey === 'est_per_diem'
                                                ? formatPrice(
                                                    container.est_per_diem
                                                  )
                                                : ''}
                                              {objectKey === 'lfd'
                                                ? formatDateTimeToUTC(
                                                    container.last_free_day
                                                  )
                                                : ''}
                                              {objectKey === 'dual'
                                                ? container.return_dual_terminals
                                                : ''}
                                            </td>
                                          );
                                        }
                                      )}
                                    </tr>
                                  ) : (
                                    <tr
                                      onClick={() =>
                                        handlematch(
                                          container.id,
                                          'em',
                                          i,
                                          container.inventory_id
                                        )
                                      }
                                      className={
                                        selectedContainer?.selectedMatch?.id ===
                                        container.id
                                          ? cls.tableRowSelected
                                          : selectedContainer?.empties?.includes(
                                              container.id
                                            ) &&
                                            selectedContainer?.selected.type ===
                                              'ex'
                                          ? cls.selectableItem
                                          : selectedContainer?.selected?.id ===
                                            container.id
                                          ? cls.tableRowSelected
                                          : cls.tableRowImport
                                      }
                                      style={{ flex: 1, minHeight: 40 }}>
                                      {EmptiesTableTheadTitle.map(
                                        (header, index) => {
                                          const objectKey = header.object;

                                          return header?.show === false ? (
                                            ''
                                          ) : (
                                            <td
                                              key={`${index}new`}
                                              className={cls.tableTDMain}
                                              style={{
                                                flex: header.flex,
                                              }}>
                                              {objectKey === 'name'
                                                ? container.name
                                                : ''}
                                              {objectKey === 'chases'
                                                ? container.chases
                                                : ''}
                                              {objectKey === 'gated_out'
                                                ? formatDateTimeToUTC(
                                                    container.gated_out
                                                  )
                                                : ''}
                                              {objectKey === 'gated_in'
                                                ? formatDateTimeToUTC(
                                                    container.gated_in
                                                  )
                                                : ''}
                                              {objectKey === 'loc'
                                                ? em?.address?.city
                                                : ''}
                                              {objectKey ===
                                              'return_appointment'
                                                ? 'No Apt. Available'
                                                : ''}
                                              {objectKey === 'return_terminals'
                                                ? container.return_terminals
                                                : ''}
                                              {objectKey === 'est_per_diem'
                                                ? formatPrice(
                                                    container.est_per_diem
                                                  )
                                                : ''}
                                              {objectKey === 'lfd'
                                                ? formatDateTimeToUTC(
                                                    container.last_free_day
                                                  )
                                                : ''}
                                              {objectKey === 'dual'
                                                ? container.return_dual_terminals
                                                : ''}
                                            </td>
                                          );
                                        }
                                      )}
                                    </tr>
                                  )}
                                </>
                              )
                            )
                          )}
                        </td>
                        <td
                          style={{
                            height:
                              Object.values(i?.exports || {}).reduce(
                                (sum, ex) => sum + (ex.bookings_count || 0),
                                0
                              ) <=
                              Object.values(i?.empties || {}).reduce(
                                (sum, em) => sum + (em.containers_count || 0),
                                0
                              )
                                ? `${
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : Object.values(i?.exports || {}).reduce(
                                    (sum, ex) => sum + (ex.bookings_count || 0),
                                    0
                                  ) >
                                  Object.values(i?.empties || {}).reduce(
                                    (sum, em) =>
                                      sum + (em.containers_count || 0),
                                    0
                                  )
                                ? `${
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : '49px',
                            flex: 0.0001,
                          }}
                          className={cls.tableTDMatchBtn}>
                          {newDataList[idx]?.matchedContainersManual.map(
                            (container, mchca) => (
                              <tr
                                className={cls.tableRowUnmatchBtn}
                                style={{ flex: 1 }}>
                                <td
                                  className={cls.tableTDMain}
                                  style={{ flex: 1 }}>
                                  <Tooltip
                                    arrow
                                    title="Unmatch"
                                    placement="top">
                                    <IconButton
                                      aria-label="unmatch"
                                      onClick={() =>
                                        handleUnMatchApi(
                                          newDataList[idx]
                                            ?.matchedContainersManual[mchca].id,
                                          newDataList[idx]
                                            ?.matchedBookingsManual[mchca].id,
                                          newDataList[idx]
                                            ?.matchedContainersManual[mchca]
                                            .inventory_id,
                                          newDataList[idx]
                                            ?.matchedBookingsManual[mchca]
                                            .export_id
                                        )
                                      }>
                                      <ReactSVG
                                        src={Icons.forbidden}
                                        className={cls.icon}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                              </tr>
                            )
                          )}
                          <tr
                            className={cls.tableRowUnmatchSmartBtn}
                            style={{ flex: 1 }}>
                            {smartMatchStatus
                              ? newDataList[idx]?.matchedContainersSmart
                                  ?.length > 0
                                ? newDataList[idx]?.matchedContainersSmart.map(
                                    (container, mchca) => (
                                      <td
                                        className={cls.tableTDMain}
                                        style={{ flex: 1 }}>
                                        <IconButton aria-label="unmatch">
                                          <ReactSVG
                                            src={Icons.forbidden}
                                            className={cls.icon}
                                          />
                                        </IconButton>
                                      </td>
                                    )
                                  )
                                : ''
                              : ''}
                          </tr>
                        </td>
                        <td
                          style={{
                            height:
                              Object.values(i?.exports || {}).reduce(
                                (sum, ex) => sum + (ex.bookings_count || 0),
                                0
                              ) <=
                              Object.values(i?.empties || {}).reduce(
                                (sum, em) => sum + (em.containers_count || 0),
                                0
                              )
                                ? `${
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.empties || {}).reduce(
                                      (sum, em) =>
                                        sum + (em.containers_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : Object.values(i?.exports || {}).reduce(
                                    (sum, ex) => sum + (ex.bookings_count || 0),
                                    0
                                  ) >
                                  Object.values(i?.empties || {}).reduce(
                                    (sum, em) =>
                                      sum + (em.containers_count || 0),
                                    0
                                  )
                                ? `${
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      38 +
                                    Object.values(i?.exports || {}).reduce(
                                      (sum, ex) =>
                                        sum + (ex.bookings_count || 0),
                                      0
                                    ) *
                                      10.9
                                  }px`
                                : '49px',
                            flex: 0.589,
                          }}
                          className={cls.tableTD}>
                          {/* Render matched bookings in the same order as matched containers */}
                          {newDataList[idx]?.matchedContainersManual.map(
                            (container, mchca) => {
                              const booking =
                                newDataList[idx]?.matchedBookingsManual[mchca];
                              if (!booking) return null;

                              return (
                                <tr
                                  key={`manual-match-${booking.id}`}
                                  className={cls.tableRowMatched}
                                  style={{ ...gradientManualStyle, flex: 1 }}>
                                  {ExportsTableTheadTitle.map(
                                    (header, index) => {
                                      const objectKey = header.object;
                                      return header?.show === false ? (
                                        ''
                                      ) : (
                                        <td
                                          key={`${index}new`}
                                          className={cls.tableTDMain}
                                          style={{ flex: header.flex }}>
                                          {objectKey === 'booking'
                                            ? booking?.name
                                            : ''}
                                          {objectKey === 'name'
                                            ? booking?.container
                                            : ''}
                                          {objectKey === 'empty_released'
                                            ? formatDateTimeToUTC(
                                                booking?.empty_released
                                              )
                                            : ''}
                                          {objectKey === 'gated_in'
                                            ? formatDateTimeToUTC(
                                                booking?.gated_in
                                              )
                                            : ''}
                                          {objectKey === 'pickup_location'
                                            ? booking?.address?.city
                                            : ''}
                                          {objectKey === 'vessel'
                                            ? booking?.vessel_name
                                            : ''}
                                          {objectKey === 'voyage'
                                            ? booking?.vessel_voyage_in
                                            : ''}
                                          {objectKey === 'return_appointment'
                                            ? 'No Apt. Available'
                                            : ''}
                                          {objectKey === 'erd'
                                            ? formatDateTimeToUTC(booking?.erd)
                                            : ''}
                                          {objectKey === 'cutoff'
                                            ? formatDateTimeToUTC(
                                                booking?.cutoff
                                              )
                                            : ''}
                                          {objectKey === 'terminal_return'
                                            ? booking?.return_to_terminal?.slug
                                            : ''}
                                          {objectKey === 'vessel_departure'
                                            ? booking?.vessel_departure
                                            : ''}
                                        </td>
                                      );
                                    }
                                  )}
                                  <td
                                    className={cls.tableTDMain}
                                    style={{ flex: 1 }}>
                                    <span className={cls.savingSpan}>
                                      {formatPrice(booking.saving)}
                                      <ReactSVG
                                        src={Icons.dicsount}
                                        className={cls.dicsounticon}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              );
                            }
                          )}

                          {/* Render smart matched bookings in the same order as smart matched containers */}
                          {smartMatchStatus &&
                            newDataList[idx]?.matchedContainersSmart.map(
                              (container, mchca) => {
                                const booking =
                                  newDataList[idx]?.matchedBookingsSmart[mchca];
                                if (!booking) return null;

                                return (
                                  <tr
                                    key={`smart-match-${booking.id}`}
                                    className={cls.tableRowMatchedSmart}
                                    style={{ ...gradientStyle, flex: 1 }}>
                                    {ExportsTableTheadTitle.map(
                                      (header, index) => {
                                        const objectKey = header.object;
                                        return header?.show === false ? (
                                          ''
                                        ) : (
                                          <td
                                            key={`${index}new`}
                                            className={cls.tableTDMain}
                                            style={{ flex: header.flex }}>
                                            {objectKey === 'booking'
                                              ? booking?.name
                                              : ''}
                                            {objectKey === 'name'
                                              ? booking?.container
                                              : ''}
                                            {objectKey === 'empty_released'
                                              ? formatDateTimeToUTC(
                                                  booking?.empty_released
                                                )
                                              : ''}
                                            {objectKey === 'gated_in'
                                              ? formatDateTimeToUTC(
                                                  booking?.gated_in
                                                )
                                              : ''}
                                            {objectKey === 'pickup_location'
                                              ? booking?.address?.city
                                              : ''}
                                            {objectKey === 'vessel'
                                              ? booking?.vessel_name
                                              : ''}
                                            {objectKey === 'voyage'
                                              ? booking?.vessel_voyage_in
                                              : ''}
                                            {objectKey === 'return_appointment'
                                              ? 'No Apt. Available'
                                              : ''}
                                            {objectKey === 'erd'
                                              ? formatDateTimeToUTC(
                                                  booking?.erd
                                                )
                                              : ''}
                                            {objectKey === 'cutoff'
                                              ? formatDateTimeToUTC(
                                                  booking?.cutoff
                                                )
                                              : ''}
                                            {objectKey === 'terminal_return'
                                              ? booking?.return_to_terminal
                                                  ?.slug
                                              : ''}
                                            {objectKey === 'vessel_departure'
                                              ? booking?.vessel_departure
                                              : ''}
                                          </td>
                                        );
                                      }
                                    )}
                                    <td
                                      className={cls.tableTDMain}
                                      style={{ flex: 1 }}>
                                      <span
                                        className={cls.savingSpanSmartMatch}>
                                        {formatPrice(booking.saving)}
                                        <ReactSVG
                                          src={Icons.dicsount}
                                          className={cls.dicsounticon}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                );
                              }
                            )}

                          {/* Render unmatched bookings */}
                          {newDataList[idx]?.exports.map((ex, exIdx) =>
                            Object.values(ex?.bookings)
                              .map((booking, bookingIdx) => {
                                // Check if this booking is manually matched
                                const isManuallyMatched = newDataList[
                                  idx
                                ]?.matchedManualBookingIDs.includes(booking.id);
                                // Check if this booking is smart matched
                                const isSmartMatched =
                                  smartMatchStatus &&
                                  newDataList[
                                    idx
                                  ]?.matchedSmartBookingIDs.includes(
                                    booking.id
                                  );

                                // Skip matched bookings as they are rendered above
                                if (isManuallyMatched || isSmartMatched) {
                                  return null;
                                }

                                // Determine row styling based on match status
                                let rowClass = cls.tableRow;
                                let rowStyle = { flex: 1, minHeight: 40 };
                                let savingSpanClass = cls.savingSpan;

                                if (isManuallyMatched) {
                                  rowClass = cls.tableRowMatched;
                                  rowStyle = {
                                    ...gradientManualStyle,
                                    flex: 1,
                                  };
                                } else if (isSmartMatched) {
                                  rowClass = cls.tableRowMatchedSmart;
                                  rowStyle = { ...gradientStyle, flex: 1 };
                                  savingSpanClass = cls.savingSpanSmartMatch;
                                } else {
                                  // For unmatched bookings, check if they should be selectable
                                  if (
                                    selectedContainer?.exports?.includes(
                                      booking.id
                                    ) &&
                                    selectedContainer?.selected.type === 'em'
                                  ) {
                                    rowClass = cls.selectableItem;
                                  } else if (
                                    selectedContainer?.selectedMatch?.id ===
                                    booking.id
                                  ) {
                                    rowClass = cls.tableRowSelected;
                                  } else if (
                                    selectedContainer?.selected?.id ===
                                    booking.id
                                  ) {
                                    rowClass = cls.tableRowSelected;
                                  }
                                }

                                return (
                                  <tr
                                    key={`${exIdx}-${bookingIdx}`}
                                    onMouseEnter={() => {
                                      if (
                                        !isManuallyMatched &&
                                        !isSmartMatched
                                      ) {
                                        setHover(true);
                                        setSavings(booking.saving);
                                      }
                                    }}
                                    onMouseLeave={() => {
                                      if (
                                        !isManuallyMatched &&
                                        !isSmartMatched
                                      ) {
                                        setHover(false);
                                      }
                                    }}
                                    onClick={() => {
                                      if (
                                        !isManuallyMatched &&
                                        !isSmartMatched
                                      ) {
                                        handlematch(
                                          booking.id,
                                          'ex',
                                          i,
                                          null,
                                          booking.export_id
                                        );
                                      }
                                    }}
                                    className={rowClass}
                                    style={rowStyle}>
                                    {ExportsTableTheadTitle.map(
                                      (header, index) => {
                                        const objectKey = header.object;
                                        return header?.show === false ? (
                                          ''
                                        ) : (
                                          <td
                                            key={`${index}new`}
                                            className={cls.tableTDMain}
                                            style={{ flex: header.flex }}>
                                            {objectKey === 'booking'
                                              ? booking?.name
                                              : ''}
                                            {objectKey === 'name'
                                              ? booking?.container
                                              : ''}
                                            {objectKey === 'empty_released'
                                              ? formatDateTimeToUTC(
                                                  booking?.empty_released
                                                )
                                              : ''}
                                            {objectKey === 'gated_in'
                                              ? formatDateTimeToUTC(
                                                  booking?.gated_in
                                                )
                                              : ''}
                                            {objectKey === 'pickup_location'
                                              ? ex?.address?.city
                                              : ''}
                                            {objectKey === 'vessel'
                                              ? booking?.vessel_name
                                              : ''}
                                            {objectKey === 'voyage'
                                              ? booking?.vessel_voyage_in
                                              : ''}
                                            {objectKey === 'return_appointment'
                                              ? 'No Apt. Available'
                                              : ''}
                                            {objectKey === 'erd'
                                              ? formatDateTimeToUTC(
                                                  booking?.erd
                                                )
                                              : ''}
                                            {objectKey === 'cutoff'
                                              ? formatDateTimeToUTC(
                                                  booking?.cutoff
                                                )
                                              : ''}
                                            {objectKey === 'terminal_return'
                                              ? booking?.return_to_terminal
                                                  ?.slug
                                              : ''}
                                            {objectKey === 'vessel_departure'
                                              ? booking?.vessel_departure
                                              : ''}
                                          </td>
                                        );
                                      }
                                    )}
                                    <td
                                      className={cls.tableTDMain}
                                      style={{ flex: 1 }}>
                                      {isManuallyMatched || isSmartMatched ? (
                                        <span className={savingSpanClass}>
                                          {formatPrice(booking.saving)}
                                          <ReactSVG
                                            src={Icons.dicsount}
                                            className={cls.dicsounticon}
                                          />
                                        </span>
                                      ) : hover === true &&
                                        ((selectedContainer?.exports?.includes(
                                          booking.id
                                        ) &&
                                          selectedContainer?.selected.type ===
                                            'em') ||
                                          selectedContainer?.selected?.id ===
                                            booking.id) &&
                                        savings[booking.id] ? (
                                        <span className={cls.savingSpan}>
                                          {formatPrice(savings[booking.id])}
                                          <ReactSVG
                                            src={Icons.dicsount}
                                            className={cls.dicsounticon}
                                          />
                                        </span>
                                      ) : (
                                        ''
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                              .filter(Boolean)
                          )}
                        </td>
                      </tr>
                    )
                  )
                }
              </tbody>
            </table>
          </div>
        </div>
      )}
      <Options
        key={tableType}
        noTitleAndIcon={true}
        options={tableType === 'streetTurnExportsTable' ? optionsEx : optionsEm}
        tableType={
          tableType === 'streetTurnExportsTable'
            ? 'streetTurnExportsTable'
            : 'streetTurnEmptiesTable'
        }
        setTableType={
          tableType === 'streetTurnExportsTable'
            ? setExportsTitle
            : setEmptiesTitle
        }
        EmptiesTableTheadTitle={emptiesTitle}
        ExportsTableTheadTitle={exportsTitle}
        toggled={
          tableType === 'streetTurnExportsTable'
            ? optionsEx.open
            : optionsEm.open
        }
        setOptions={
          tableType === 'streetTurnExportsTable' ? setOptionsEx : setOptionsEm
        }
        mainToggleButtonRef={
          tableType === 'streetTurnExportsTable' ? optionsExRef : optionsEmRef
        }
      />
    </>
  );
};
